import React from 'react';
import {Grid} from 'semantic-ui-react';
import './Application.css';

export default (props) =>
    <div>
        <div style={{position: "absolute", width: "100vw", height: "100%"}}></div>
        <Grid padded className="bg">
            <Grid.Row className="application-row">
                    <Grid.Column stretched>
                        {props.children}
                    </Grid.Column>
            </Grid.Row>
        </Grid>
    </div>


// WEBPACK FOOTER //
// ./src/components/application/AppContainer.jsx